// BlurPassShader.js

'use strict'


var glslify = require('glslify');


var BlurPassShader = {

  transparent: true,

  blending: 0,

  depthTest: false,

  depthWrite: false,

  side: 0,

  uniforms: {
    'tDiffuse': { type: 't', value: null },
    'direction': { type: 'v2', 'value': new THREE.Vector2( 1, 0 ) },
    'resolution': {
      type: 'v2',
      'value': new THREE.Vector2( window.innerWidth, window.innerHeight )
    },
    'blurScale': { type: 'f', value: 0 },
    
  },

  vertexShader: glslify('./PassShader.vert'),

  fragmentShader: glslify('./BlurPassShader.frag')

};

module.exports = BlurPassShader;
